import { render, staticRenderFns } from "./ListUploadedFiles.vue?vue&type=template&id=20d475ec&scoped=true&"
import script from "./ListUploadedFiles.vue?vue&type=script&lang=js&"
export * from "./ListUploadedFiles.vue?vue&type=script&lang=js&"
import style0 from "./ListUploadedFiles.vue?vue&type=style&index=0&id=20d475ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d475ec",
  null
  
)

export default component.exports